// src/assets/ts/faqItems.ts

// FAQ項目の型定義
export type FAQItem = {
	question: string;
	answer: string;
};

// FAQカテゴリの型定義
export type FAQCategory = {
	category: string;
	items: FAQItem[];
};

// FAQのモックデータ
export const mockFAQCategories: FAQCategory[] = [
	{
		category: "補償についての質問",
		items: [
			{
				question: "保険の対象とは何ですか？",
				answer:
					"保険の対象とは、保険事故によって損害が生じる可能性のある保険契約の対象物（例：建物や家財など）を指します。",
			},
			{
				question: "居住用の住宅とは何ですか？",
				answer:
					"生活設備（居住室、炊事設備、トイレ等）を備えており、人が常時居住している建物を指します。<br>生活設備を備えていない建物（工場、倉庫、店舗、事務所など）や、生活設備を備えていても人が常時居住していない住宅は、居住用住宅には該当しません。",
			},
			{
				question: "地震が原因で発生した火災は補償されますか？",
				answer:
					"いいえ。<br>火災保険では「地震を起因として発生した火災」による損害は原則、補償の対象外となります。ただし、地震火災費用の補償を付帯している場合には、保険金額の一部（通常5%、ただし上限あり）が支払われます（詳細は契約内容によります）。<br>また、地震保険に加入している場合は、「地震が原因の火災」も補償対象となりますが、支払い基準や補償金額には上限が設けられています。",
			},
			{
				question:
					"地震が原因で発生した津波による被害は、保険で補償されますか？",
				answer:
					"火災保険では、「地震・噴火またはこれらによる津波を原因とする損害」は補償されません。<br>ただし、地震保険を契約している場合は、「地震もしくは噴火、または、これらによる津波を直接・間接の原因とする火災・損壊・埋没・流失」によって生じた損害が「全損」「大半損」「小半損」「一部損」に該当する場合に、保険金が支払われます。<br>なお、地震保険も、保険の対象（建物・家財）に限って補償されます。自動車などは津波で損害を受けても保険の対象に含まれないため、補償されません。地震保険は、完全復旧が主な目的ではなく、被災者の生活を復旧する費用に充てることが目的となるため、設定できる補償額には上限があります。",
			},
			{
				question:
					"もらい火で自宅が延焼した場合、隣家の火災保険で補償されますか？",
				answer:
					" ご自宅が火災保険に加入していれば、ご自身の火災保険で補償を受けられますが、火元となった隣家が加入している火災保険からは、原則として補償を受けることはできません。これは「失火責任法（民法709条）」（失火者（火元となった人）に故意や重大な過失がない限り、民法の不法行為に基づく賠償責任を問うことができないと定めた法律）によるものです。<br>ただし、隣家の火災保険に「類焼損害補償特約」が付帯されている場合、ご自身の火災保険で十分な補償が受けられないときは支払いの対象となる場合があります（適用には条件があります）。",
			},
			{
				question:
					"マンションで水漏れを起こした場合、火災保険で下の階への損害を補償できますか？",
				answer:
					"いいえ。<br>火災保険では補償されませんが、「個人賠償責任特約」等の特約を付帯している場合、法律上の損害賠償責任を負ったときに、損害を補償できることがあります。ただし、原因や状況によって補償されない場合もあります。",
			},
		],
	},
	{
		category: "加入・解約について",
		items: [
			{
				question: "火災保険を途中解約したら、保険料は戻ってきますか？",
				answer:
					"はい。<br>長期契約の火災保険を期間の途中で解約した場合、残りの保険期間に応じて未経過分の保険料が一定額返還されます（解約返戻金）。<br>なお、戸建てや分譲住宅だけでなく、賃貸住宅の場合も同様です。引っ越しなどで火災保険の契約期間（通常１～２年）の途中で解約する場合も返金の対象になりますが、詳しくは保険会社にご確認ください。",
			},
			{
				question:
					"住宅ローンを組む際に、銀行指定の火災保険に入らないといけないのですか？",
				answer:
					"いいえ。<br>銀行指定の保険でなければいけない、という決まりはなく、一般的には銀行指定以外の火災保険でも加入可能です。ただし、火災保険の契約内容に、住宅ローンの条件について定められている場合があります。例えば、金融機関が算出した評価額以上の補償があること、保険期間が住宅ローン支払期間相当であること、などがあります。",
			},
			{
				question: "契約後に補償内容を変更できますか？",
				answer:
					"ご契約内容や保険会社の取扱いによっては、契約後に補償内容の変更が可能な場合があります。<br>詳細はお問い合わせください。<br><a href='/contact'>お問い合わせはこちら</a>",
			},
			{
				question:
					"賃貸物件の火災保険は、不動産会社指定の保険に入らないといけないのですか？",
				answer:
					"いいえ。<br>多くの場合、不動産会社経由での保険を推奨されますが、法的には指定の保険への加入義務はありません。<br>ただし、入居の際に、大家への借家人賠償責任補償や、近隣への個人賠償責任補償を目的として、火災保険への加入を必須としていることが一般的です。そのため、賠償責任が付いた家財保険に加入することをおすすめします。補償額など大家が条件を定めていることもあります。個別契約の場合は、事前に管理会社や大家にご相談のうえ、条件を確認してください。",
			},
		],
	},
	{
		category: "見積もりについての質問",
		items: [
			{
				question:
					"屋根に設置されているソーラーパネルは、建物の保険金額に含まれますか？",
				answer:
					"はい。<br>ソーラーパネル（太陽光発電設備）の所有者が建物所有者と同じ場合、建物の保険金額に追加して補償対象とします。例えば、建物の保険金額が2,000万円・ソーラーパネルが200万円の場合は、合計2,200万円で保険金額を設定します。詳細は保険会社によって取扱いが異なる場合があるため、ご契約時にご確認ください。",
			},
		],
	},
	{
		category: "保険金請求時の質問",
		items: [
			{
				question: "保険金を請求した場合、更新時に保険料が高くなりますか？",
				answer:
					"いいえ。<br>保険金を請求したこと自体が、次回の保険料に直接影響することは通常ありません。ただし、商品改定や保険料率の変更などによって、更新時に保険料が高くなる可能性はあります。",
			},
		],
	},
	// {
	// 	category: "サービスについての質問",
	// 	items: [
	// 		{
	// 			question: "火災保険一括見積もりは、どのようなサービスですか？",
	// 			answer:
	// 				"株式会社Bangの提供する火災保険一括見積もりサービスは、ご自宅の物件情報など必要事項をご入力いただくことで、ご希望の条件に合った複数社の火災保険見積もりをご提供するサービスです。<br>株式会社Bangでは、提携している株式会社ウェブクルーが運営する「保険スクエアbang! 火災保険 保険料シミュレーションサービス」から利用申込みいただいた方へサービス提供しております。<br><a href='https://fire.bang.co.jp/compare/'>火災保険料シミュレーションサービス（外部サイト）</a>",
	// 		},
	// 	],
	// },
	{
		category: "そのほかの質問",
		items: [
			{
				question: "火災保険はいらないと聞いたのですが、本当に必要ですか？",
				answer:
					"火災保険は、ご自身が原因となる火災だけでなく、近隣からの延焼や、台風・水災など自然災害も含めたさまざまなリスクに備える重要な保険です。<br>また、火災以外の自然災害など、住まいにまつわる損害も幅広く補償できるため、ご自身では防ぎきれない損害リスクへの備えとして、加入の必要性がある保険といえます。",
			},
			{
				question: "建物を増築した場合、火災保険を見直すべきですか？",
				answer:
					"はい。<br>建物の価額（補償対象となる資産の総額）が増えるため、保険金額等の見直しが必要です。また、建物構造や用途が変わった場合も契約内容の変更が必要なことがあります。増築や用途変更を行った際は、保険会社・保険代理店(株式会社Bang）へご相談ください。",
			},
			{
				question: "火災保険に保険料控除はありますか？",
				answer:
					"2025年9月時点では、火災保険料は原則として所得控除の対象になりません。2008年1月の税制改正により、損害保険料控除制度が廃止されました。<br>地震保険については「地震保険料控除」が設けられていますので、火災保険とあわせて地震保険に加入されている場合、地震保険料のみが「地震保険料控除」の対象となります。保険会社から送付される「地震保険料控除証明書」をご確認ください。<br>なお、地震保険料の控除は、賃貸住宅で加入されている地震保険にも適用されます。<br>※税制は改正される場合がありますので、最新の情報は国税庁等の公的機関でご確認ください。",
			},
			// {
			// 	question: "火災保険の保険料相場は、いくらですか？",
			// 	answer:
			// 		"火災保険の保険料は、戸建てとマンション、建物の構造や築年数、所在地や補償内容などによって大きく異なります。目安となる金額は保険会社・条件ごとに異なりますので、複数社の見積もりを比較されることをおすすめします。<br>株式会社Bangでは、提携している株式会社ウェブクルーが運営する「保険スクエアbang! 火災保険 保険料シミュレーションサービス」から利用申込みいただいた方へ複数社の火災保険料を一括比較できるサービスを提供しております。<br><a href='https://fire.bang.co.jp/compare/'>火災保険料シミュレーションサービス（外部サイト）</a>",
			// },
		],
	},
];
